"use client";

import React from 'react';
import { useState, useEffect } from 'react';
import { Segmented } from 'antd';
import Image from "next/image";
import { getWallet, getMarketData, marketBuy, marketSell } from "@/service/common/index";
import Search from "@/app/components/layout-widgets/search/index";

import './index.css'

import btn_ic_close_png from "@/app/assets/common/event/btn_ic_close.png";
import btn_icon_diamond_png from "@/app/assets/common/btn_icon_diamond.png";
import small_diamond_png from "@/app/assets/common/event/small_diamond.png";
import img_title_sucess_png from "@/app/assets/event/img_title_sucess.png";
import ic_arrow_up_png from "@/app/assets/event/ic_arrow_up.png";

export type EventCardProps = {
  data: MarketDataType,
  type: number,
  onClose: () => void
};

export type MarketDataType = {
  aiPrediction: string,
  chanceDisplay?: string,
  id: number,
  image?: string,
  itemTitle: string,
  outcomeName1: string,
  outcomeName2: string,
  outcomePrice1: number,
  outcomePrice2: number,
  question?: string
}
export const BuySell: React.FC<EventCardProps> = ({
  data,
  type,
  onClose,
  ...props
}) => {
  const [type1, setType1] = useState(1)
  const [balance, setBalance] = useState(0)
  const [userPosition, setUserPosition] = useState<null | {
    position: number,
    outcomeName: string
  }[]>(null)
  const defaultAmount = data.outcomePrice1 * 3
  const defaultAmount2 = data.outcomePrice2 * 3

  const [amount, setAmount] = useState(defaultAmount)
  const [successData, setSuccessData] = useState<null | {
    sellAmount: number,
    betAmount: number,
    betPrice: number,
    orderId: string,
    outcomeName: string,
    shares: number
  }>(null)
  const [shares, setShares] = useState(0)
  const [buyIdx, setBuyIdx] = useState(-1)
  const [sellIdx, setSellIdx] = useState(-1)
  const [sellShares, setSellShares] = useState(0)
  const [isBuyYes, setIsBuyYes] = useState(type === 1 ? true : false)

  const [isSellYes, setIsSellYes] = useState(true)
  const [sellIdxBtn, setSellIdxBtn] = useState(0)

  const [curoutcomeName, setCuroutcomeName] = useState("")
  const [curoutcomePrice, setCuroutcomePrice] = useState("")

  useEffect(() => {
    getWallet({}).then(res => {
      if (res.code === 401) {
        globalThis.localStorage.setItem("login_redirect", location.href)
        document.getElementById("signInButton")?.click();
        // @ts-ignore
        globalThis.googleLoginOK = () => {
          getWallet({}).then(res => {
            if (res.code === 0) {
              const b1 = res.data.balance
              setBalance(b1)
              setAmount(defaultAmount > b1 ? b1 : defaultAmount)

              getMarketData(data.id).then(res => {
                if (res.code === 0) {
                  const arr = res.data.userPosition
                  if (arr && arr.length) {
                    setShares(arr[0].position)
                    setSellShares(arr[0].position)
                    setUserPosition([...arr])
                  }
                }
              })
            }
          })
        }
      } else if (res.code === 0) {
        const b1 = res.data.balance
        setBalance(b1)
        setAmount(defaultAmount > b1 ? b1 : defaultAmount)

        getMarketData(data.id).then(res => {
          if (res.code === 0) {
            const arr = res.data.userPosition
            if (arr && arr.length) {
              setShares(arr[0].position)
              setSellShares(arr[0].position)
              setUserPosition([...arr])
            }
          }
        })
      }
    })

  }, [])

  const buyFunc = () => {
    marketBuy({
      marketId: data.id,
      amount,
      outcomeName: isBuyYes ? data.outcomeName1 : data.outcomeName2,
    }).then(res => {
      if (res.code === 0) {
        //
        setSuccessData({
          ...res.data
        })
      } else {
        // 
      }
    })
  }

  const sellFunc = () => {
    marketSell({
      marketId: data.id,
      shares: sellShares,
      outcomeName: sellIdxBtn === 0 ? data.outcomeName1 : data.outcomeName2,
    }).then(res => {
      if (res.code === 0) {
        //
        setSuccessData({
          ...res.data
        })
      } else {
        // 
      }
    })
  }

  const plusFunc = (num: number, idx: number) => {
    if (idx === buyIdx) {
      if (isBuyYes) {
        setAmount(defaultAmount > balance ? balance : defaultAmount)
      } else {
        setAmount(defaultAmount2 > balance ? balance : defaultAmount2)
      }
      setBuyIdx(-1)
    } else {
      setBuyIdx(idx)
      if (isBuyYes) {
        setAmount(num + defaultAmount > balance ? balance : num + defaultAmount)
      } else {
        setAmount(num + defaultAmount2 > balance ? balance : num + defaultAmount2)
      }
    }
  }

  const reduceFunc = (num: number, idx: number) => {
    if (idx === sellIdx) {
      // setAmount(defaultAmount > balance ? balance : defaultAmount)
      setSellIdx(-1)
      //setSellShares(shares)
    } else {
      setSellIdx(idx)
      const sr = Math.ceil(shares * num)
      //setSellShares(sr)
    }
  }

  useEffect(() => {
    if (userPosition) {
      if (-1 === sellIdx) {
        setSellShares(userPosition[sellIdxBtn].position)
      } else {
        let sr = 0
        const shares = userPosition[sellIdxBtn].position
        // setSellIdx(idx)
        if (sellIdx === 1) {
          sr = Math.ceil(shares * 0.1)
          //setSellShares(sr)
        } else if (sellIdx === 2) {
          sr = Math.ceil(shares * 0.2)
        } else if (sellIdx === 3) {
          sr = shares
        }
        setSellShares(sr)
      }
    }
  }, [sellIdx, sellIdxBtn])

  useEffect(() => {
    if (balance) {
      if (isBuyYes) {
        if (buyIdx === 1) {
          setAmount(100 + defaultAmount > balance ? balance : 100 + defaultAmount)
        } else if (buyIdx === 2) {
          setAmount(200 + defaultAmount > balance ? balance : 200 + defaultAmount)
        } else if (buyIdx === 3) {
          setAmount(1000 + defaultAmount > balance ? balance : 1000 + defaultAmount)
        } else if (buyIdx === 4) {
          setAmount(balance)
        } else if (buyIdx === -1) {
          setAmount(defaultAmount)
        }
      } else {
        if (buyIdx === 1) {
          setAmount(100 + defaultAmount2 > balance ? balance : 100 + defaultAmount2)
        } else if (buyIdx === 2) {
          setAmount(200 + defaultAmount2 > balance ? balance : 200 + defaultAmount2)
        } else if (buyIdx === 3) {
          setAmount(1000 + defaultAmount2 > balance ? balance : 1000 + defaultAmount2)
        } else if (buyIdx === 4) {
          setAmount(balance)
        } else if (buyIdx === -1) {
          setAmount(defaultAmount2)
        }
      }
    }
  }, [isBuyYes, balance])

  const classNamePlusBtn = 'operationItem font-bold text-15 leading-18 text-bravve-200 flex items-center justify-center cursor-pointer flex-1'

  return (<div>
    <div
      className='fixed bottom-0 w-full left-0 rounded-t-20 bg-bravve-bg-400 pt-10 z-40 px-20 pb-20'
      onClick={(e) => e.stopPropagation()}
    >
      <div className='absolute top-10 right-10 cursor-pointer'>
        <Image src={btn_ic_close_png} alt='close' className='w-30 h-30' width={30} height={30} onClick={onClose} />
      </div>
      <div className='text-center'>
        <Segmented
          size="large"
          value={type1}
          options={[
            { value: 1, label: "Buy" },
            { value: 2, icon: 'Sell', disabled: !userPosition }
          ]}
          onChange={(value) => setType1(value)}
        />
      </div>
      <div className='mt-20 text-center font-bold text-15 leading-18 text-bravve-200'>
        {data.itemTitle}
      </div>

      {
        type1 === 1 ?
          <div className='flex items-center px-10 mt-15 mb-20 my-10'>
            <div className={'button_50p flex items-center justify-center font-semibold relative cursor-pointer ' +
              (isBuyYes ? 'activeBtn' : 'bg-bravve-200')} onClick={() => {
                setIsBuyYes(true)
              }}
            >
              {data.aiPrediction === data.outcomeName1 &&
                <span className='absolute text-10 text-bravve-300 font-black top-5 right-10 leading-12'>AI</span>}
              <span className='text-xs text-bravve-sub-400' >{data.outcomeName1}</span>
              <span className='text-xl ml-5 text-bravve-300' >{data.outcomePrice1}</span>
              <Image src={btn_icon_diamond_png} alt='btn_icon_diamond' width={20} height={20} className='w-20 h-20' />
            </div>

            <div className={'button_50p flex items-center justify-center font-semibold relative ml-10 cursor-pointer ' +
              (!isBuyYes ? 'activeBtn' : 'bg-bravve-200')} onClick={() => {
                setIsBuyYes(false)
              }}
            >
              {data.aiPrediction === data.outcomeName2 &&
                <span className='absolute text-10 text-bravve-300 font-black top-5 right-10 leading-12'>AI</span>}
              <span className='text-xs text-bravve-sub-400' >{data.outcomeName2}</span>
              <span className='text-xl ml-5 text-bravve-300' >{data.outcomePrice2}</span>
              <Image src={btn_icon_diamond_png} alt='btn_icon_diamond' width={20} height={20} className='w-20 h-20' />
            </div>
          </div>
          :
          userPosition && userPosition.length ?
            <div className='flex items-center px-10 mt-15 mb-20 my-10 gap-10'>
              {
                userPosition.map((itemP, idx) => <div
                  key={idx}
                  className={'button_50p flex items-center justify-center font-semibold relative cursor-pointer flex-1 ' +
                    (sellIdxBtn === idx ? 'activeBtn' : 'bg-bravve-200')} onClick={() => {
                      setSellIdxBtn(idx)
                    }}
                >
                  {data.aiPrediction === itemP.outcomeName &&
                    <span className='absolute text-10 text-bravve-300 font-black top-5 right-10 leading-12'>AI</span>}
                  <span className='text-xs text-bravve-sub-400' >{itemP.outcomeName}</span>
                  <span className='text-xl ml-5 text-bravve-300' >{itemP.outcomeName === data.outcomeName1 ? data.outcomePrice1 : data.outcomePrice2}</span>
                  <Image src={btn_icon_diamond_png} alt='btn_icon_diamond' width={20} height={20} className='w-20 h-20' />
                </div>)
              }
            </div>
            :
            null
      }

      <div
        style={{ background: '#1E1A40', border: '0.2rem solid #8273FF', borderRadius: '0.4rem' }}
        className='flex items-center justify-between h-50 mx-10 px-10'
      >
        {
          type1 === 1 ?
            <>
              <div className='flex items-center'>
                <Image src={small_diamond_png} alt='small_diamond' width={20} height={20} className='w-20 h-20' />
                <span className='text-15 leading-18 text-bravve-sub-500 ml-5'>Amount</span>
              </div>
              <span className='font-bold text-32 leading-38 text-bravve-200 '>{amount}</span>
            </>
            :
            <>
              <div className='flex items-center'>
                <span className='text-15 leading-18 text-bravve-sub-500'>Shares</span>
              </div>
              <span className='font-bold text-32 leading-38 text-bravve-200 '>{sellShares}</span>
            </>
        }
      </div>

      <div className='flex items-center justify-around mt-20 px-10 gap-10'>
        {
          type1 === 1 ?
            <>
              <div className={classNamePlusBtn + (buyIdx === 1 ? ' operationItem_active' : '')} onClick={() => { plusFunc(100, 1) }}>+100</div>
              <div className={classNamePlusBtn + (buyIdx === 2 ? ' operationItem_active' : '')} onClick={() => { plusFunc(200, 2) }}>+200</div>
              <div className={classNamePlusBtn + (buyIdx === 3 ? ' operationItem_active' : '')} onClick={() => plusFunc(1000, 3)}>+1000</div>
              <div className={classNamePlusBtn + (buyIdx === 4 ? ' operationItem_active' : '')} onClick={() => plusFunc(balance, 4)}>ALL IN</div>
            </>
            :
            <>
              <div className={classNamePlusBtn + (sellIdx === 1 ? ' operationItem_active' : '')} onClick={() => { reduceFunc(0.1, 1) }}>10%</div>
              <div className={classNamePlusBtn + (sellIdx === 2 ? ' operationItem_active' : '')} onClick={() => { reduceFunc(0.2, 2) }}>20%</div>
              <div className={classNamePlusBtn + (sellIdx === 3 ? ' operationItem_active' : '')} onClick={() => { reduceFunc(1, 3) }}>ALL IN</div>
            </>
        }
      </div>

      <div
        className='flex items-center justify-between h-50 mx-10 px-10 mt-20 rounded-sm'
        style={{ background: 'rgba(0, 0, 0, 0.2)' }}
      >
        <div className='flex items-center'>
          <Image src={small_diamond_png} alt='small_diamond' width={20} height={20} className='w-20 h-20' />
          <span className='text-15 leading-18 text-bravve-sub-500 ml-5'>
            {
              type1 === 1 ? 'To Win' : 'Receive'
            }
          </span>
        </div>
        <span className='font-bold text-32 leading-38 text-bravve-200 '>
          {
            type1 === 1 ?
              (isBuyYes ? parseInt((amount / data.outcomePrice1).toString()) * 100 : parseInt((amount / data.outcomePrice2).toString()) * 100)
              :
              (sellIdxBtn === 0 ? data.outcomePrice1 * sellShares : data.outcomePrice2 * sellShares)
          }
        </span>
      </div>

      <div className='mt-20 mb-20 text-center text-sm text-bravve-sub-500'>
        {
          type1 === 1 ?
            `Current Balence：${balance}`
            :
            (userPosition ?
              <span>Current Position：{userPosition.map((item, idx) => <span key={idx} className='mr-5'>
                <span className='ml-5 mr-4 text-bravve-200'>{item.position}</span>{item.outcomeName}</span>)}</span>
              : null)
        }
      </div>

      <div
        className='w-full h-44 rounded-sm flex items-center justify-center leading-20 text-17 font-bold text-bravve-300'
        style={{ background: '#FFED41' }}
        onClick={() => {
          type1 === 1 ?
            buyFunc()
            :
            sellFunc()
        }}
      >
        Trade Now
      </div>
    </div>
    <div className={`fixed top-0 left-0 h-full w-full ${successData ? 'z-50' : 'z-20'} bg-bravve-sub-400`} onClick={onClose}></div>
    <Search />
    {
      successData ?
        <div className='success_box'>
          <div className='success_box_content'>
            <div className='success_box_title_wrap relative'>
              <div className='text-20 leading-24 font-bold text-bravve-300'>
                Successfully<br />
                {type1 === 1 ? 'Bought' : 'Sold'} {successData.outcomeName} {successData.betPrice}
              </div>
              <Image
                src={img_title_sucess_png}
                alt='title_sucess'
                className='w-135 h-75 absolute -right-10 -top-10' width={135} height={75}
              />
            </div>
            <div className='flex items-center gap-5 mt-20'>
              <span className='text-36 leading-44 font-semibold text-bravve-300'>{type1 === 1 ? successData.betAmount : successData.sellAmount}</span>
              <Image src={btn_icon_diamond_png} alt='small_diamond' width={20} height={20} className='w-20 h-20' />
              <Image
                src={ic_arrow_up_png}
                alt='arrow_up'
                className='w-30 h-30 mx-12' width={30} height={30}
              />
              <span className='text-36 leading-44 font-semibold text-bravve-300'>{successData.shares}</span>
              <span className='text-sm leading-15 text-bravve-300'>Shares</span>
            </div>
          </div>
        </div>
        :
        null
    }

  </div>)
}